import {
  FLIGHT_TYPE_INFO,
  ROUND_TRIP,
  ONE_WAY,
  MULTI_DESTINATION
} from '../constants'

export const CABIN_OPTIONS = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Premium Economy', value: 'Premium Economy' },
  { label: 'Business', value: 'Business' },
  { label: 'First', value: 'First' }
] as const

export const FLIGHT_TYPE_OPTIONS = [
  {
    value: ROUND_TRIP,
    label: FLIGHT_TYPE_INFO[ROUND_TRIP].typeLabel
  },
  {
    value: ONE_WAY,
    label: FLIGHT_TYPE_INFO[ONE_WAY].typeLabel
  },
  {
    value: MULTI_DESTINATION,
    label: FLIGHT_TYPE_INFO[MULTI_DESTINATION].typeLabel
  }
] as const

export const PLACEHOLDERS = {
  ORIGIN: 'Departing from?',
  DESTINATION: 'Going to?',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: '1 Passenger, 1 Room',
  CABIN_CLASS: 'Economy',
  SEARCH_BUTTON: 'Search'
} as const

export const LABELS = {
  ADD_HOTEL: 'Add Hotel',
  ADD_CAR: 'Add Car',
  PACKAGE_DEALS: 'Package Deals',
  CABIN_CLASS: 'Cabin class',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: 'Passengers with Hotel'
} as const

export const DEFAULT_VALUES = {
  FLIGHT_TYPE: ROUND_TRIP,
  CABIN_CLASS: 'Economy',
  ADD_HOTEL: false,
  ADD_CAR: false
} as const
